<template>
  <div class="changepwd">
    <div class="t-nav">
      <nav>
        <ul class="r-nav">
          <li class="active"><a href="#">修改密码</a></li>
        </ul>
      </nav>
    </div>
    <el-form :model="userItem" ref="ruleForm" :rules="passwordRule" label-width="120px" class="demo-ruleForm">
      <el-form-item label="原始密码" prop="password">
        <el-input v-model="userItem.password" type="password" placeholder="原始密码"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input v-model="userItem.newPassword" type="password" placeholder="新密码"></el-input>
      </el-form-item>
      <el-form-item label="确认新密码" prop="newPassword2">
        <el-input v-model="userItem.newPassword2" type="password" placeholder="确认新密码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="danger" plain @click="submitForm">确认修改</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import eventBus from '../../common/eventBus.js'
export default {
  name: 'changepassword',
  components: {
  },
  data () {
    var validatPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入原始密码'))
      } else {
        let queryParam = { password: value }
        this.sapost('/dmc/account/unique', queryParam, r => {
          let { retCode, retMsg } = r.data
          if (retCode === '1') {
            callback(new Error(retMsg))
          } else {
            callback()
          }
        })
      }
    }
    var validatNewPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else {
        let queryParam = { newPassword: value }
        this.sapost('/dmc/account/unique', queryParam, r => {
          let { retCode, retMsg } = r.data
          if (retCode === '1') {
            callback(new Error(retMsg))
          } else {
            callback()
          }
        })
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.userItem.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      userItem: {
        password: '',
        newPassword: '',
        newPassword2: ''
      },
      passwordRule: {
        password: [
          { validator: validatPass }
        ],
        newPassword: [
          { pattern: /^(?![0-9A-Z]+$)(?![0-9a-z]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/, message: '必须包含数字、大小写字母，且至少六位' },
          { validator: validatNewPass }
        ],
        newPassword2: [
          { validator: validatePass2 }
        ]
      }
    }
  },
  methods: {
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let Account = {
            password: this.userItem.password,
            newPassword: this.userItem.newPassword,
            newPassword2: this.userItem.newPassword2
          }
          let e = JSON.stringify(Account)
          this.$http({
            method: 'post',
            url: '/dmc/account/changePwd',
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: e
          }).then(r => {
            let { retMsg, retCode } = r.data
            if (retCode === '0') {
              this.$message.success(retMsg)
              eventBus.$emit('logout')
            } else {
              this.$message.warning(retMsg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="less">
.changepwd{
  margin-left: 200px;
  padding-left: 30px;
  background-color: #fff;
  min-height: 500px;
  .t-nav {
    nav{
      border-bottom: 2px solid #ddd;
      ul {
        margin-right: 150px;
        height: 60px;
        color: #b4b8bb;
        li{
          float: left;
          height: 60px;
          line-height: 60px;
          font-size: 15px;
          margin-right: 45px;
          a{
            color:#b4b8bb;
          }
        }
        li.active,li:hover {
          border-bottom: 2px solid #f01400;
          a{
            color:#f01400;
          }
        }
      }
    }
  }
  .demo-ruleForm{
    overflow: hidden;
    margin-top: 25px;
    label{
      text-align: left;
    }
    input{
      width: 50%;
    }
    button{
      margin-left: 276px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/userCenter/changepassword.vue